<template>
  <v-list dense class="b-ate-tree-form-recursive pa-0">
    <component
      :is="isLast ? 'v-list-item' : 'v-list-group'"
      v-model="node.isActive"
      :append-icon="isLoading ? 'mdi-spin mdi-sync' : void 0"
      :ripple="false"
      no-action
      class="pa-0 b-ate-tree-form-recursive__item"
      @click="onLoadChildren"
    >
      <template #[headerSlotName]>
        <v-list-item-icon class="mr-1">
          <BAteTreeFormRecursiveCheckbox
            :node="node"
            :readonly="readonly"
            :clearable="clearable"
            :parent_mode="parent_mode"
            @change="$emit('change', node)"
          />
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title
            v-text="node.data.name"
          />
        </v-list-item-content>

        <v-list-item-icon v-if="clearable && node.isSelected">
          <BTooltipButton
            icon="mdi-close"
            tooltip="Удалить"
            depressed
            small
            top
            @click.stop="$emit('clear', node, $event)"
          />
        </v-list-item-icon>
      </template>

      <template v-if="!isLast && node.isActive">
        <v-list dense class="pa-0">
          <b-ate-tree-form-recursive
            v-for="item in children"
            :key="item.data.code"
            :node="item"
            :load-children="loadChildren"
            :readonly="readonly"
            :parent_mode="parent_mode"
            :clearable="clearable"
            class="ml-6"
            v-on="$listeners"
          />
        </v-list>
      </template>
    </component>
  </v-list>
</template>

<script>
import { VListGroup, VListItem } from 'vuetify/lib'
import BAteTreeFormRecursiveCheckbox from './BAteTreeFormRecursiveCheckbox.vue'
import BTooltipButton from '@/components/common/BTooltipButton.vue'


export const BATCH_COUNT = 10
export const BATCH_TIMEOUT = 150

export default {
  name: 'BAteTreeFormRecursive',
  components: {
    VListGroup,
    VListItem,
    BAteTreeFormRecursiveCheckbox,
    BTooltipButton,
  },
  props: {
    readonly: Boolean,
    clearable: Boolean,
    parent_mode: Boolean,
    node: {
      type: Object,
      required: true,
    },
    loadChildren: {
      type: Function,
      default: () => () => ({}),
    },
    maxLevel: {
      type: Number,
      default: 3,
    },
  },
  data() {
    return {
      isLoading: false,
      batchCount: 0,
    }
  },
  computed: {
    headerSlotName() {
      return this.isLast ? 'default' : 'activator'
    },
    children() {
      return this.node.children.slice(0, this.batchCount)
    },
    isLast() {
      const { node } = this

      if (this.parent_mode || !this.readonly) {
        return node.isLast || node.level >= this.maxLevel
      }

      return node.isLast || (node.isSelected && !node.isIndeterminate)
    },
  },
  watch: {
    'node.isActive': {
      immediate: true,
      handler(value) {
        if (!value) return
        this.$nextTick(this.updateBatch)
      },
    },
  },
  beforeDestroy() {
    clearTimeout(this.timerId)
  },
  methods: {
    updateBatch() {
      clearTimeout(this.timerId)
      this.timerId = setTimeout(() => {
        this.batchCount += BATCH_COUNT
        if (this.batchCount < this.node.children.length) {
          this.$nextTick(this.updateBatch)
        }
      }, BATCH_TIMEOUT)
    },
    async onLoadChildren() {
      if (this.isLast || this.node.children.length) {
        // this.node.isActive = !this.node.isActive
        return
      }

      try {
        this.isLoading = true
        await this.loadChildren(this.node)
        this.node.isActive = true
      } catch (error) {
        this.node.isActive = false
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style lang="scss">

.b-ate-tree-form-recursive {
  &__item {
    cursor: default !important;
  }

  .v-list-item,
  &.v-list-item {
    padding: 0 6px !important;
  }

  .v-list-group {
    &__header {
      cursor: default !important;
    }

    &__header__append-icon.v-list-item__icon {
      min-width: 24px !important;
      margin-left: 8px !important;
    }

    &__items {
      padding-left: 20px;
    }
  }
}
</style>
